/**
 * Deadline utilities for calculating urgent delivery dates (J-2 or overdue)
 */

export const getDeadlineAlert = (order) => {
    if (!order || !order.appointmentDate) return null;
    const status = (order.status || '').toLowerCase();

    // Do not alert on completed, delivered, or invoiced orders
    if (status === 'livré' || status === 'facturé' || status === 'terminé') return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dueDate = new Date(order.appointmentDate);
    if (isNaN(dueDate.getTime())) return null;
    dueDate.setHours(0, 0, 0, 0);

    const diffTime = dueDate - today;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
        const days = Math.abs(diffDays);
        return {
            isUrgent: true,
            isOverdue: true,
            days: days,
            label: `Retard (${days}j)`,
            shortLabel: `Retard +${days}j`,
            badgeClass: 'deadline-badge overdue',
            priority: 1
        };
    } else if (diffDays === 0) {
        return {
            isUrgent: true,
            isOverdue: false,
            days: 0,
            label: `Échéance Aujourd'hui !`,
            shortLabel: `Aujourd'hui !`,
            badgeClass: 'deadline-badge today',
            priority: 2
        };
    } else if (diffDays <= 2) {
        return {
            isUrgent: true,
            isOverdue: false,
            days: diffDays,
            label: `Échéance J-${diffDays}`,
            shortLabel: `J-${diffDays}`,
            badgeClass: 'deadline-badge urgent',
            priority: 3
        };
    }

    return null;
};
